import { Paper, Table as MuiTable, TableBody, TableCell, TableContainer, TableHead, TableRow, styled, Typography } from '@mui/material'
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAvailabilityConstraints } from '../../../hooks'
import { theme } from '../../../modules/App/Providers/Theme/theme'
import { AvailabilityConstraint } from '../../../types'
import { Container as LoaderContainer, Loader } from '../../Loader'
import { ConstraintModal } from '../ConstraintModal'
import { DtoCalendarConstraint } from '../types'
import { Constraint } from './Constraint'

const HeaderCell = styled(TableCell)`
  font-size: 1rem;
  font-weight: 500;
  line-height: 2rem;
`

const Table = styled(MuiTable)(({ theme }) => ({
  '& tbody > tr:nth-of-type(odd)': {
    backgroundColor: theme.palette.grey[50],
  },
}))

const List = () => {
  const { availabilityConstraints, isLoading } = useAvailabilityConstraints()
  const { t } = useTranslation()
  const [isEditorOpen, beEditorOpen] = useState(false)
  const [constraint, setConstraint] = useState({} as DtoCalendarConstraint)

  const onEditorClose = useCallback(() => beEditorOpen(false), [])

  const onConstraintClick = useCallback((constraint: DtoCalendarConstraint) => {
    setConstraint(constraint)
    beEditorOpen(true)
  }, [])

  const hasAvailabilityConstraints = Boolean(availabilityConstraints && availabilityConstraints.length)

  return (
    <div style={{ marginTop: '1rem', width: 'calc(100vw - 3rem)' }}>
      <TableContainer component={Paper} elevation={0} variant="elevation">
        <Table>
          <TableHead>
            <TableRow>
              <HeaderCell align="left">{t('common.label.appointmentType')}</HeaderCell>
              <HeaderCell align="center">{t('common.label.startDate')}</HeaderCell>
              <HeaderCell align="center">{t('common.label.from')}</HeaderCell>
              <HeaderCell align="center">{t('common.label.to')}</HeaderCell>
              <HeaderCell align="center">{t('common.label.endDate')}</HeaderCell>
              <HeaderCell align="left">{t('common.label.occurrence')}</HeaderCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading && (
              <TableRow key="loading">
                <TableCell align="center" colSpan={6}>
                  <LoaderContainer>
                    <Loader />
                  </LoaderContainer>
                </TableCell>
              </TableRow>
            )}
            {!isLoading && !hasAvailabilityConstraints && (
              <TableRow key="no-data">
                <TableCell align="center" colSpan={6}>
                  <Typography color={theme.palette.grey[400]} fontWeight={400}>
                    {t('pages.settings.resources.availabilityConstraints.list.messages.noConstraintsFound')}
                  </Typography>
                </TableCell>
              </TableRow>
            )}
            {availabilityConstraints?.map((constraint: AvailabilityConstraint) => (
              <Constraint constraint={constraint} key={constraint.id} onClick={onConstraintClick} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <ConstraintModal constraint={constraint} isOpen={isEditorOpen} isNew={false} onClose={onEditorClose} />
    </div>
  )
}

export { List }
